module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("EXTREME"), _c('br'), _vm._v("CROCHET"), _c('br'), _c('span', {
    staticClass: "title1"
  }, [_vm._v("WITH CHUNKY YARN")])]), _vm._v(" "), _c('h2', {
    staticClass: "description"
  }, [_vm._v("8 QUICK CROCHET PROJECTS FOR HOME & ACCESSORIES")]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("SARAH SHRIMPTON")]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/logo.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stitchcraftcreate.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.stitchcraftcreate.co.uk")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee2d35c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = 60
// module chunks = 0